// extracted by extract-css-chunks-webpack-plugin
module.exports = {"nwEOChiclet":"_2S8S3T","text":"uG_j6w","nwLogoContainer":"c486WH","sparkleImage":"_1dwueZ"};